import { styled } from '@mui/material/styles';

import Page from '../Components/Page/Page';

export const RootStyle = styled(Page)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));
